const mailValidationRegex =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const thousandSeparator = (x, separator = '.') => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

export { mailValidationRegex, thousandSeparator };
